import {http} from '@/utils';
import globalStore from '@/services/global.state';

export function postReceiveBox(userId: number, level: number) {
  return http.post('app/membershipCard/getReceiveRewards', {
    userId,
    level: level + 1,
  });
}

export interface VipConfigVO {
  /**
   * 当前总经验
   */
  currentExperience?: number;
  /**
   * 等级权益 提现每日次数
   */
  dailyWithdrawalLimitCount?: number;
  /**
   * 距离下一级充值差值
   */
  diff?: number;
  /**
   * 等级奖励 奖金金额
   */
  leveBonusAmount?: number;
  /**
   * 会员等级
   */
  level?: number;
  /**
   * 会员等级名称
   */
  name?: string;
  /**
   * 下一等级充值目标
   */
  nextLevelExperience?: number;
  /**
   * 奖励领取状态
   */
  rewardVipLevelReceivingStatus?: number;
  /**
   * 赠送刮刮卡张数
   */
  scratchCount?: number;
  /**
   * 赠送刮刮卡名称
   */
  scratchName?: string;
  /**
   * 等级权益 提现单笔手续费系数
   */
  singleWithdrawalFeeCoefficient?: number;
  /**
   * 等级权益 提现单笔上限金额
   */
  singleWithdrawalLimitAmount?: number;
  /**
   * 转盘次数
   */
  spinCount?: number;
  /**
   * 达成状态
   */
  statusReached?: number;
  /**
   * 周奖励 基础奖金金额
   */
  weekBaseBonusAmount?: number;
}
export function getVipConfigListV2() {
  return http
    .post<null, VipConfigVO[]>('app/vip/getVipConfigList')
    .then(res => {
      localStorage.setItem('vipConfigList', JSON.stringify(res));
      return res;
    });
}

// 如果返回true，则表示有领取奖励的消息，出现红点
export function getVipAboutRewardStatus() {
  return http
    .post<null, boolean>('app/vip/getUserVipAboutRewardStatus')
    .then(res => {
      globalStore.vipRedPointSubject.next(!!res);
      return res;
    });
}

export function checkPopupVipUpgrade() {
  return http.post<
    null,
    {
      status: boolean;
      changeExperience: number;
    }
  >('app/vip/checkVipUserInfoUpgrade');
}

export function receiveVipLevelReward(level: number) {
  return http.post<null, boolean>('app/vip/getVipLevelReward', {
    level,
  });
}

/**
 * VipWeekCardConfigVO
 */
export interface VipWeekCardConfigVO {
  /**
   * 立即返还奖励
   */
  bonus?: number;
  /**
   * 周卡by天奖励 金钱
   */
  bonusAmount?: number;
  /**
   * 周卡主键
   */
  cardId?: number;
  /**
   * 周卡名称
   */
  cardName?: string;
  /**
   * 单价
   */
  price?: number;
  /**
   * 周卡by天奖励 刮刮卡次数
   */
  scratchCount?: number;
  /**
   * 周卡 刮刮卡 天数
   */
  scratchDay?: number;
  /**
   * 赠送刮刮卡名称
   */
  scratchName?: string;
  /**
   * 周卡by天奖励 大转盘
   */
  spinCount?: number;
  /**
   * 周卡 大转盘 天数
   */
  spinDay?: number;
}

export function getVipWeekCardList() {
  return http.post<null, VipWeekCardConfigVO[]>(
    'app/vip/getVipWeekCardConfigList',
  );
}

export function buyVipWeekCard(cardId: number) {
  return http.post<null, boolean>('app/vip/buyVipWeekCard', {
    cardId,
  });
}

/**
 * VipWeekCardTimeVO
 */
export interface VipWeekCardTimeVO {
  /**
   * 周卡名称
   */
  cardName?: string;
  /**
   * 结束时间 时间戳
   */
  endTime?: string;
  /**
   * 开始时间 时间戳
   */
  startTime?: string;
  /**
   * 有效天数
   */
  validDay?: number;
}

export function getVipWeekCardDays() {
  return http.post<null, VipWeekCardTimeVO[]>('app/vip/getVipWeekCardTimeList');
}

export function weekRewardReceive() {
  return http.post<
    null,
    {bonusAmount: number; multiple: number; weekBaseBonusAmount: number}
  >('app/vip/getVipWeekRewardBannerData');
}

/**
 * VipWeekCardRewardBannerDataVO
 */
export interface VipWeekCardRewardBannerDataVO {
  /**
   * 周卡总奖励 金钱
   */
  bonusAmount?: number;
  /**
   * 周卡名称
   */
  cardName?: string;
  /**
   * 周卡by天奖励 刮刮卡次数
   */
  scratchCount?: number;
  /**
   * 周卡 刮刮卡 天数
   */
  scratchDay?: number;
  /**
   * 周卡by天奖励 大转盘
   */
  spinCount?: number;
  /**
   * 周卡 大转盘 天数
   */
  spinDay?: number;
}

export function weekCardReceive() {
  return http.post<null, VipWeekCardRewardBannerDataVO[]>(
    'app/vip/getVipWeekCardRewardBannerData',
  );
}

/**
 * VipWeekCardRewardLogVO
 */
export interface VipWeekCardRewardLogVO {
  /**
   * 周卡名称
   */
  cardName?: string;
  vipWeekCarRewardLogInWeekVO?: VipWeekCarRewardLogInWeekVO[];
}

/**
 * VipWeekCarRewardLogInWeekVO
 */
export interface VipWeekCarRewardLogInWeekVO {
  /**
   * 周卡by天奖励 金钱
   */
  bonusAmount?: number;
  /**
   * 自然天数  （有效期内当前时间 与周卡开始时间 间隔天数）取7模 +1
   */
  day?: number;
  /**
   * 周卡by天奖励 刮刮卡次数
   */
  scratchCount?: number;
  /**
   * 赠送刮刮卡名称
   */
  scratchName?: string;
  /**
   * 周卡by天奖励 大转盘
   */
  spinCount?: number;
  /**
   * status 领取状态状态 -1=无当天奖励 0=未领取 1=人工审核（未领取）  2=已领取',
   */
  status?: number;
}

export function getVipWeekCardRewardList() {
  return http.post<null, VipWeekCardRewardLogVO[]>(
    'app/vip/getVipWeekCardRewardLogList',
  );
}

/**
 * BuyVipWeekCardLogVo
 */
export interface BuyVipWeekCardLogVo {
  /**
   * cardId
   */
  cardId?: number;
  /**
   * cardName
   */
  cardName?: string;
  /**
   * 创建时间
   */
  createTime?: string;
  id?: number;
  /**
   * 订单号
   */
  orderNo?: string;
  /**
   * 付款金额
   */
  price?: number;
  /**
   * 买卡状态 0= 待支付 1=已支付 2= 支付取消 3=支付失败
   */
  status?: number;
  /**
   * 买卡状态 0= 待支付 1=已支付 2= 支付取消 3=支付失败
   */
  statusName?: string;
}

export function getWeekCardBuyRecord(pageNo: number) {
  return http.post<null, BuyVipWeekCardLogVo[]>('app/vip/buyVipWeekCardLog', {
    pageNo,
  });
}
